import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="readablestreamdefaultcontroller" id="readablestreamdefaultcontroller"></a>
    <h1 {...{
      "id": "windowreadablestreamdefaultcontroller"
    }}>{`window.ReadableStreamDefaultController`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ReadableStreamDefaultController"
      }}>{`Web APIs - ReadableStreamDefaultController`}</a>{`  `}</p>
    <a name="readablestreamdefaultcontroller-desiredsize" id="readablestreamdefaultcontroller-desiredsize"></a>
    <h2 {...{
      "id": "desiredsize--number"
    }}>{`desiredSize : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`Returns the desired size to fill the controlled stream’s internal queue.
It can be negative, if the queue is over-full.`}</p>
    <a name="readablestreamdefaultcontroller-close" id="readablestreamdefaultcontroller-close"></a>
    <h2 {...{
      "id": "close"
    }}>{`close()`}</h2>
    <p>{`Closes the controlled readable stream.
Consumers will still be able to read any previously-enqueued chunks from the stream,
but once those are read, the stream will become closed.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the source is not a ReadableStreamDefaultController`}</li>
    </ul>
    <a name="readablestreamdefaultcontroller-enqueue" id="readablestreamdefaultcontroller-enqueue"></a>
    <h2 {...{
      "id": "enqueuechunk"
    }}>{`enqueue(chunk)`}</h2>
    <p>{`Enqueues the given chunk in the controlled readable stream.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the source is not a ReadableStreamDefaultController`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`chunk`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="readablestreamdefaultcontroller-error" id="readablestreamdefaultcontroller-error"></a>
    <h2 {...{
      "id": "errorerror"
    }}>{`error(error)`}</h2>
    <p>{`Errors the controlled readable stream, making all future interactions with it fail with the given error.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the source object is not a ReadableStreamDefaultController`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`error`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      